import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "../components/Navbar";
import Home from "../pages/Home";
import Regulations from "../pages/Regulations";
import About from "../pages/About";
import Pricing from "../pages/Pricing";
import Contact from "../pages/Contact";
import Footer from "../components/Footer";
import WebTechnology from "../pages/WebTechnology";
import ForexCRM from "../pages/ForexCRM";
import ForexWebdesign from "../pages/ForexWebdesign";



function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/WebTechnology" element={<WebTechnology/>} />
        <Route path="/" element={<Home />} />
        <Route path="/regulation" element={<Regulations/>} />
        <Route path="/about" element={<About />} />
        
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forex-crm" element={<ForexCRM/>} />
        <Route path="/forex-webdesign" element={<ForexWebdesign/>} />
        
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
